
  import InputDefault from '@/components/main/ui/InputDefault.vue'

  export default {
    components: {
      InputDefault,
    },

    props: {
      modelValue: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: 'large',
      },
      status: {
        type: Boolean,
        default: false,
      },
      statusMsg: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      maxLength: {
        type: Number,
        default: 32,
      },
      required: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    emits: ['update:modelValue'],

    data() {
      return {
        visible: false,
        typeInput: 'password',
      }
    },

    computed: {},

    mounted() {},

    methods: {
      toggleVisible() {
        this.visible = !this.visible
        this.typeInput = this.typeInput === 'text' ? 'password' : 'text'
      },
    },
  }
